import { render, staticRenderFns } from "./TheMainMenu.vue?vue&type=template&id=179d3791&scoped=true"
import script from "./TheMainMenu.vue?vue&type=script&lang=js"
export * from "./TheMainMenu.vue?vue&type=script&lang=js"
import style0 from "./TheMainMenu.vue?vue&type=style&index=0&id=179d3791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d3791",
  null
  
)

export default component.exports